import { css } from 'aphrodite';
import ThankYouIllustrationUrl from '../../../../assets/illustrations/donationsThankYou.svg';
import { DonationSurveyHeader } from '../DonationSurveyHeader';
import { styleSheet } from '../styles';

export const ThankYouMessage = () => {
	return (
		<div className={css(styleSheet.thankYouContainer)}>
			<DonationSurveyHeader description={''} />

			<div className={css(styleSheet.illustrationContainer)}>
				<img className={css(styleSheet.illustration)} src={ThankYouIllustrationUrl} alt='Thank You' />
			</div>

			<div className={css(styleSheet.thankYouMessageContainer)}>
				<p className={css(styleSheet.thankYouMessage)}>Thank You for your Donation!</p>

				<p>You can now close this window.</p>
			</div>
		</div>
	);
};
